<script setup>
import { onMounted, ref } from 'vue';
const view = ref(false)

onMounted(()=>{
  require('@/assets/js/mutual-fund-return.js')
})
</script>
<template>
  <main class="mutual-fund-return-new" id="mutual-func-return-cal">
    <!-- breadcrumb template -->
    <section class="breadcrumbs-sec">
      <div class="container breadcrumbs-ol">
        <div class="stocks-indices-breadcrumbs_wrap">
          <ol class="stocks-indices-breadcrumbs">
            <li>
              <a href="/">
                <span>Trading </span>
              </a>
            </li>
            <li>
              <a >
                <span>Calculators </span>
              </a>
            </li>
            <li>
              <span>Mutual Fund Returns Calculator </span>
            </li>
          </ol>
        </div>
      </div>
    </section>
    <!-- end breadcrumb template -->

    <section class="mutual-fund-background">
      <div class="calc-mob-heading">
        <h1 class="title">Mutual Fund Returns Calculator</h1>
        <h2 class="description">
          Get a quick estimate on your Mutual Fund returns.
        </h2>
      </div>
    </section>

    <section class="calculator">
      <div class="container">
        <div class="cal-structure">
          <div class="inner-row cal-slider" id="cal-slider">
            <div class="input-section calc-slide">
              <div class="calc-slide-inner">
                <h1 class="title">Mutual Fund Returns Calculator</h1>
                <h2 class="description">
                  Get a quick estimate on your Mutual Fund returns.
                </h2>
                <div class="form-group investment-main">
                  <label for="investment">
                    <h2>Total Investment</h2>
                  </label>
                  <input
                    type="text"
                    id="investment"
                    value="₹ 100000"
                    class="input"
                  />
                  <ul class="number-tags">
                    <li value="500">+500</li>
                    <li value="1000">+1k</li>
                    <li value="10000">+10k</li>
                  </ul>
                </div>

                <!-- input -->
                <div class="form-group">
                  <label>
                    <h3>Expected Return Rate</h3>
                  </label>
                  <span class="input-wrapper">
                    <button class="decrement">-</button>
                    <input
                      type="text"
                      value="12%"
                      class="quantity input"
                      id="return-rate"
                    />
                    <button class="increment">+</button>
                  </span>
                </div>
                <!-- END input -->
                <div class="form-group">
                  <label>
                    <h3>Time Period</h3>
                  </label>
                  <span class="input-wrapper">
                    <button class="decrement">-</button>
                    <input
                      type="text"
                      value="1 year"
                      class="quantity input"
                      id="time-period"
                    />
                    <button class="increment">+</button>
                  </span>
                </div>
                <div class="mob-calc-btn">
                  <button id="calculate" class="calc-btn-mob">Calculate</button>
                </div>
              </div>
            </div>
            <div class="output-section calc-slide cal-loader">
              <div class="calc-slide-inner">
                <lottie-player
                  src="/json-data/lottie/calculator-loader.json"
                  background="transparent"
                  speed="1"
                  loop=""
                  autoplay=""
                ></lottie-player>
              </div>
            </div>
            <div class="output-section calc-slide">
              <div class="calc-slide-inner">
                <div class="mob-results">
                  <h5>
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/back-arrow.svg"
                      alt=""
                      id="back-button"
                    />
                    Your results
                  </h5>
                </div>
                <h3>Total value of your investment:</h3>
                <div class="distribution-bar background-color-bar">
                  <div class="grey investment" style="width: 5674.27%"></div>
                  <div class="green returns" style="width: 4325.73%"></div>
                </div>
                <div class="invest-list">
                  <ul>
                    <li>
                      <span class="grey-circle"></span>
                      <h5>Invested Amount</h5>
                    </li>
                    <li>
                      <span class="green-circle"></span>
                      <h5>Est. Returns</h5>
                    </li>
                  </ul>
                </div>

                <div class="row outer-listing-group">
                  <div class="outer-grp">
                    <h4>Invested Amount</h4>
                    <span id="invested-amount">₹ 1,00,000</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Estimated Returns</h4>
                    <span id="est-amount">₹ 76,234</span>
                  </div>
                  <div class="outer-grp">
                    <h4>Total Returns</h4>
                    <span id="total-investment">₹ 1,76,234</span>
                  </div>
                  <div class="bottom-text">
                    <p>
                      <span class="capital-text">ZERO</span> annual maintenance
                      charges only for new users for the
                      <strong>next 10 days</strong>
                    </p>
                    <a
                      href="https://wa.me/+917092362098"
                      class="get-start-btn"
                      >Get Started Today</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--------------last 3 calculations -------------------->

    <section class="last-three-calculations">
      <div class="container last-three-cal-mobile">
        <h3>Last 3 calculations</h3>
        <p>Your calculations are erased upon refreshing!</p>
        <div class="calc-inner" id="cal-history"></div>
      </div>
    </section>

    <!--------------------Start Key Indicies Template--------------------------->

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in NSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/nifty-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 50"
                    />
                  </div>
                  <div class="key-content">NIFTY 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-next-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Next 50"
                    />
                  </div>
                  <div class="key-content">NIFTY NEXT 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-bank-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Bank"
                    />
                  </div>
                  <div class="key-content">NIFTY BANK</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 100"
                    />
                  </div>
                  <div class="key-content">NIFTY 100</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 200"
                    />
                  </div>
                  <div class="key-content">NIFTY 200</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty 500"
                    />
                  </div>
                  <div class="key-content">NIFTY 500</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-midcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="Nifty Midcap 50"
                    />
                  </div>
                  <div class="key-content">NIFTY MIDCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/nifty-smlcap-50-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="NIFTY SMLCAP 50"
                    />
                  </div>
                  <div class="key-content">NIFTY SMLCAP 50</div>
                </a>
              </li>
              <li>
                <a href="/indices/india-vix-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="India VIX"
                    />
                  </div>
                  <div class="key-content">INDIA VIX</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="key-indices">
      <div class="container">
        <div class="key-indices-inner">
          <div class="key-indices-header">
            <h4>Key Indices in BSE</h4>
          </div>
          <div class="key-indices-content">
            <ul>
              <li>
                <a href="/indices/sensex-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SENSEX"
                    />
                  </div>
                  <div class="key-content">SENSEX</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse100-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE100"
                    />
                  </div>
                  <div class="key-content">BSE100</div>
                </a>
              </li>
              <li>
                <a href="/indices/lrgcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="LRGCAP"
                    />
                  </div>
                  <div class="key-content">LRGCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/midcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="MIDCAP"
                    />
                  </div>
                  <div class="key-content">MIDCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/smlcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMLCAP"
                    />
                  </div>
                  <div class="key-content">SMLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse500-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE500"
                    />
                  </div>
                  <div class="key-content">BSE500</div>
                </a>
              </li>
              <li>
                <a href="/indices/allcap-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="ALLCAP"
                    />
                  </div>
                  <div class="key-content">ALLCAP</div>
                </a>
              </li>
              <li>
                <a href="/indices/bse200-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSE200"
                    />
                  </div>
                  <div class="key-content">BSE200</div>
                </a>
              </li>
              <li>
                <a href="/indices/bseipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="BSEIPO"
                    />
                  </div>
                  <div class="key-content">BSEIPO</div>
                </a>
              </li>
              <li>
                <a href="/indices/smeipo-share-price/">
                  <div class="key-icon">
                    <img
                      src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/indices-graph.svg"
                      alt="SMEIPO"
                    />
                  </div>
                  <div class="key-content">SMEIPO</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!--------------------END Key Indicies Template--------------------------->

    <!-- Calculator Qna Section -->

    <section class="container calculator-info">
      <h2>What are Mutual Funds?</h2>
      <p></p>
      <p>
        A Mutual Fund is an investment option where a group of investors pool in
        their money, to be collectively invested across stocks, shares, bonds
        and other securities. There is usually a fund manager who invests this
        money on their behalf and charges a small fee. This is an ideal
        investment option for people who are looking to invest their money but
        do not have the time to look for the right investment option.
      </p>
      <p></p>
      <h2>Types of Mutual Funds</h2>
      <p></p>
      <div class="types-of-mutual-fund">
        <p>
          Mutual Fund can be of various types, each suitable for different
          investment goals.
        </p>
        <p>
          <b>Equity (Growth) Funds</b> – These are funds with their assets
          invested only in stocks. They grow faster than money market and
          fixed-income funds. Naturally, they also involve more risk.
        </p>
        <p>
          <b>Fixed-Income Funds</b> – These are funds invested only in
          fixed-income securities. These funds pay a fixed rate of return,
          similar to government bonds, investment-linked corporate bonds and
          high-yield corporate bonds. These are considered safer investment
          options as the risk is less and the returns are usually consistent.
        </p>
        <p>
          <b>Balanced</b> – These funds are invested partly in stocks and partly
          in fixed-income securities in order to maintain a balance between high
          returns and risk. The money is split among different investments. The
          risk is higher than fixed income funds, but still lesser than that of
          pure equity funds.
        </p>
        <p>
          <b>Money Market Funds</b> – These funds are invested in short-term
          fixed income securities such as government bonds, treasury bills,
          commercial paper and certificates of deposit. They are considered a
          safe investment option, but with a lower potential return than other
          Mutual Funds.
        </p>
        <p>
          <b>Index Funds</b> – These funds aim to track the performance of a
          specific index such as Sensex or Nifty. The value of the Mutual Fund
          fluctuates with the value of the index.
        </p>
        <p>
          <b>Sectoral Funds</b> – These funds are invested in stocks belonging
          to specific sectors such as real estate, commodities, or companies
          that support social causes such as environmental welfare and human
          rights.
        </p>
        <p>
          <b>Fund-of-funds</b> – These funds invest in other funds. They are
          similar to balanced funds, where they make asset allocation and
          diversification easier.
        </p>
      </div>
      <p></p>
      <h2>Lump Sum v/s SIP?</h2>
      <p></p>
      <p>
        You can choose to invest in Mutual Funds via a single lump sum
        investment or smaller regular investments made periodically (weekly,
        monthly, or quarterly) known as SIPs. There are various advantages of
        choosing SIPs over lump sum. The investment required is low; investors
        can start as low as ₹100 per month. The power of compounding also
        ensures that interest earned from previous instalments are reinvested.
        SIPs also help create the habit of disciplined savings. However, when
        the market is down, lump sum investments may be preferred as it will
        earn higher returns.
      </p>
      <p></p>
    </section>
    <!-- Calculator Faqs Section-->

    <section class="faqs">
      <div class="container">
        <div class="faq-card nav-list" id="faq">
          <div class="faq-card-details stock-card-header">
            <div class="faq-card-desc">
              <h2 class="heading">Frequently Asked Questions</h2>
            </div>
          </div>
          <div class="stock-card-content dynamic-faq" id="dynamic-faq">
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-1">
                <h3 class="panel-title">
                  <span class="panel-trigger" data-toggle="collapse" data-parent="#dynamic-faq" href="#collapse-1">
                    <span class="flex-grow"
                      >Can there be negative returns on Mutual Funds?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="Can there be negative returns on Mutual Funds?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-1" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    Yes, there is always a risk of negative returns when
                    investing in Mutual Funds. However, with some financial
                    planning and assistance from experts, such situations<br />
                    can be avoided.
                  </p>
                </div>
              </div>
            </div>
            <div class="panel panel-default">
              <div class="panel-heading" id="faq-2">
                <h3 class="panel-title">
                  <span class="panel-trigger" val="#collapse-2" data-toggle="collapse" data-parent="#dynamic-faq" href="#collapse-2">
                    <span class="flex-grow"
                      >How many Mutual Fund schemes are there in India?</span
                    >
                    <div class="icon-arrow">
                      <img
                        src="https://upstox.com/app/themes/upstox/dist/img/mutual-funds-return/faq-arrow.svg"
                        alt="How many Mutual Fund schemes are there in India?"
                      />
                    </div>
                  </span>
                </h3>
              </div>
              <div id="collapse-2" class="panel-collapse collapse">
                <div class="panel-body">
                  <p class="visible">
                    According to data released by SEBI, there were 1,013 mutual
                    fund schemes in India
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Similar Calculator Section-->
    <!-- text start similar-->
    <section class="similar_section">
      <div class="container">
        <div class="heading-wrap">
          <h2 class="fs-28 bold help_here">Similar Calculator</h2>
          <button class="similar-btn btn-all" :class="!view?'':'hidden'" @click="view=!view">View all</button>
          <button class="similar-btn btn-less" :class="view?'':'hidden'" @click="view=!view">
            View less
          </button>
        </div>
        <div class="smooth-wrap" :class="!view?'':'smooth-wrap2'">
          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Brokerage Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Margin Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                SIP Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a > NPV Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Future Value Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a > SWP Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a > ELSS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Option Value Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a > NPS Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                
              >
                PPF Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                
              >
                Compound Annual Growth Rate Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                
              >
                National Savings Certificate Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Sukanya Samriddhi Yojana Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Compound Interest Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Atal Pension Yojana Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Gratuity calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Simple Interest Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a >
                Fixed Deposit Calculator</a
              >
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a > GST Calculator</a>
            </h3>
          </div>

          <div class="smooth-font">
            <span class="img-wrap">
              <img
                src="https://upstox.com/app/themes/upstox/dist/img/calculator/icon.png"
                alt="Upstox Calculators"
                class="simi-image"
              />
            </span>
            <h3>
              <a
                
              >
                HRA Calculator</a
              >
            </h3>
          </div>
        </div>
      </div>
    </section>
    <!-- Calculator Disclaimer Section -->
    <section class="container calculator-disclaimer">
      <p></p>
      <p>
        Disclaimer:<br />
        This calculator is meant to be used for indicative purposes only. It is
        designed to assist you in determining the appropriate amount of
        prospective investments. This calculator alone is not sufficient and
        shouldn’t be used for the development or implementation of any
        investment strategy. Upstox does not take the responsibility/liability
        nor does it undertake the authenticity of the figures calculated
        therein. Upstox makes no warranty about the accuracy of the
        calculators/reckoners. The examples do not claim to represent the
        performance of any security or investments. In view of the individual
        nature of tax consequences, each investor is advised to consult his/her
        own professional tax advisor before making any investment decisions on
        the basis of the results provided through the use of this calculator.
      </p>
      <p></p>
    </section>
  </main>
</template>
<style src="@/styles/css/mutual-fund-latest.scss" lang="scss" scoped></style>
<style src="@/styles/css/seo-calculators.scss" lang="scss" scoped></style>
<style scoped>
</style>
